import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from "primeng/api";
import { HelpersService } from '../../../../services/helpers.service'
import { RentalsService } from '../../../../services/rentals.service'
import { ProductsService } from "src/app/services/products.service";
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-add-edit-product-categories',
  templateUrl: './add-edit-product-categories.component.html',
  styleUrls: ['./add-edit-product-categories.component.scss'],
  providers: [MessageService]
})
export class AddEditProductCategoriesComponent implements OnInit {

  @Input() category;
  @Input() messageService;
  @Input() allowSecurityDeposit = false;
  public busy : boolean = false;
  public partner : any = {};

  public products: any = [];
  public searchResult: any = [];

  constructor(
    private rentalsService : RentalsService,
    private helpersService : HelpersService,
    private productsService : ProductsService,
    public modal: NgbActiveModal,
    private translate : TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
  }

  valid(){
    return this.category.categoryName && this.category.categoryName.length > 0 && (!this.allowSecurityDeposit || !this.category.deductSecurityDeposit || (this.allowSecurityDeposit && this.category.deductSecurityDeposit && this.category.securityDepositAmount));
  }

  saveCategory(){    
    this.busy = true;
    if(this.category.id){
      this.rentalsService.updateRentalProductCategory(this.category).subscribe(res=>{
        this.messageService.add({life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_updated', {categoryName: this.category.categoryName})});
        this.busy = false;
        this.modal.close(this.category);
      });
    }else{
      const data = { 
        ...this.category,
        categoryName: this.category.categoryName, 
        defaultPartnerID: this.helpersService.getPartnerId(), 
        isActive: true
      };
      this.rentalsService.addRentalProductCategory(data).subscribe(res=>{
        this.messageService.add({life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_added', {categoryName: this.category.categoryName})});
        this.busy = false;
        this.modal.close(this.category);
      });
    }
  }  

  removeCategory(){
    if(this.category.id){      
      this.confirmationService.confirm({
        rejectLabel: this.translate.instant('general.no'),
        acceptLabel: this.translate.instant('general.yes'),
        message: this.translate.instant('bikeshop.rentals.category.confirm_remove_category', {categoryName: this.category.categoryName}),
        accept: () => {
          this.busy = true;
          const data = {...this.category, isActive: false};
          this.rentalsService.updateRentalProductCategory(data).subscribe(res=>{
            this.messageService.add({life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_removed', {categoryName: this.category.categoryName})});
            this.busy = false;
            this.modal.close(this.category);
          });
        },
        reject: () => {
         
        }
      });      
    }
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase()
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }

  removeSKU(){
    this.category.internalProductID = null;
    this.category.sku = null;
    this.category.name = null
    this.category.amount = 0;
    this.category.newSku = null;
  }

  linkSku(sku) {
    console.log(sku);
    this.category.internalProductID = sku.ID;
    this.category.sku = sku.SKU;
    this.category.name = sku.Name;
    this.category.amount = 0;
    this.category.newSku = null;
  }

}
